export default {
    props: {
        action: String
    },
    data() {
        return {
            filterValue: ''
        };
    },
    methods: {
        filter() {
            this.$root.$emit(this.action, this.filterValue);
        },
        clearFilterInput() {
            this.filterValue = '';
            this.filter();

            var vm = this;

            setTimeout(() => {
                vm.$refs.filterInputField.focus();
            }, 100);
        }
    }    
};



// WEBPACK FOOTER //
// ./src/components/FilterBox/FilterBox.js